import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import tooth from "images/tooth.png";
import { AiOutlineSearch } from "react-icons/ai";
import client from "api/WookAxios";
import log from "loglevel";

const StyledBox = styled.div`
  background-color: #eaebea;
  height: 90dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SearchFrame = styled.div`
  // display: -webkit-box;
  display: flex;
  // -webkit-box-pack: space-between;
  justify-content: space-between;
  align-items: center;
  color: #323332;
  width: 400px;
  padding: 5px 0px;
  // background: palegreen;

  @media (max-width: 380px) {
    // background: red;
    width: 100%;
  }
`;

const SearchTitle = styled.div`
  color: #323332;
  font-family: "Roboto-Bold", Helvetica;
  font-size: 23px;
  font-weight: 700;
  width: 50px;
  margin-top: 2px;
  // margin-left: 7px;
  // background: red;
`;

const SearchInput = styled.input`
  // width: 270px;
  width: 77%;
  height: 27px;
  border-radius: 10px;
  border: 3px solid gray;

  outline: none;

  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 16px;
  color: #363636;

  &::placeholder {
    color: black;
  }

  &:hover {
    border: 3px solid black;
  }

  &:focus {
    color: black;
    border: 3px solid black;
  }

  // @media (max-width: 400px) {
  //   width: 60%;
  // }
`;

const SearchButton = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  // background: red;
  // background: #03c75a;
  margin-left: 5px;
  // margin-right: 10px;

  &:hover {
    background: #03c75a;
  }
`;

const Result = styled.div`
  background: palegreen;
  position: fixed;
  top: 116px;
  height: 20px;
  // display: flex;
  // align-items: center;
  padding-bottom: 4px;
  // z-index: 1050;
  z-index: 950;

  @media (max-width: 1024px) {
    top: 86px;
  }

  @media (max-width: 768px) {
    top: 96px;
  }
`;

const Map = styled.div`
  width: 95%;
  height: 100%;
`;

export const MapPage = () => {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState("");
  const { naver } = window;

  useEffect(() => {
    console.log("useEffect called");
    handleSearch();
  }, []);

  const renderMap = (practitioners) => {
    const location = new naver.maps.LatLng(
      practitioners[0].latitude,
      practitioners[0].longitude
    );
    const mapOptions = {
      center: location,
      zoom: 12,
    };

    const map = new naver.maps.Map("map", mapOptions);

    for (const practitioner of practitioners) {
      const latitude = practitioner.latitude;
      const longitude = practitioner.longitude;
      const name = practitioner.name;
      const clinic = practitioner.clinic;
      const address = practitioner.address;

      const location = new naver.maps.LatLng(latitude, longitude);
      const marker = new naver.maps.Marker({
        map,
        position: location,
        icon: {
          url: tooth,
          // origin: new naver.maps.Point(0, 0),
          // anchor: new naver.maps.Point(11, -15)
        },
      });
      marker.setTitle(`${name}, ${clinic}`);

      const info = `
        <div class="iw_inner" style={{ background: red }}>
          <h3>&nbsp&nbsp ${name}, ${clinic} &nbsp&nbsp</h3>
          <p>&nbsp&nbsp  ${address}  &nbsp&nbsp<br>
          </p>
        </div>'
      `;

      const infoWindow = new naver.maps.InfoWindow({
        content: info,
      });

      naver.maps.Event.addListener(marker, "click", (e) => {
        if (infoWindow.getMap()) {
          infoWindow.close();
        } else {
          infoWindow.open(map, marker);
        }
      });
    }
  };

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // const handleSearch = async () => {
  //   try {
  //     const response = await client.get("/api/v1/practitioners/", {
  //       query: query,
  //     });
  //     console.log("search response", response);
  //     setResult(`총 ${response.data.length}개의 결과가 있습니다.`);
  //     renderMap(response.data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const handleSearch = async () => {
    try {
      // const response = await client.get("/api/v1/practitioners/", {
      //   params: {
      //     query: query,
      //   }
      // });
      const response = await client.getPractitioners(query);
      log.debug('GET_PRACTITIONERS_SUCCESS', response);
      setResult(`총 ${response.data.length}개의 결과가 있습니다.`);
      renderMap(response.data);
    } catch (e) {
      log.debug('GET_PRACTIONERS_FAILED', e);
    }
  };

  return (
    <div className="MapPage">
      <StyledBox>
        <SearchFrame>
          <SearchTitle>검색</SearchTitle>
          <SearchInput
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="예) 교정과, 강원도, 전주시, 송파구, 유재욱"
          />
          <SearchButton onClick={handleSearch}>
            <AiOutlineSearch size="100%" />
          </SearchButton>
        </SearchFrame>
        <Result>{result}</Result>
        <Map>
          <div id="map" style={{ width: "100%", height: "100%" }}></div>
        </Map>
      </StyledBox>
    </div>
  );
};
